import { render, staticRenderFns } from "./ProductsName.vue?vue&type=template&id=0196d128&scoped=true&"
import script from "./ProductsName.vue?vue&type=script&lang=js&"
export * from "./ProductsName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0196d128",
  null
  
)

export default component.exports